// extracted by mini-css-extract-plugin
export default {"imageWrapper":"QE-z","hovered":"RE-z","hoverImage":"SE-z","mainImage":"TE-z","imageNoBackground":"UE-z","fullSizeImage":"VE-z"};